import {CommandBase} from '@shared/commands/command-base';
import {OrbitaxExcelMemoConfig} from './orbitax-excel-memo.config';
import {Configuration} from "@shared/models/configuration";


export class CreateEmptyMemoCommand extends CommandBase {
  constructor(public templateType: string, public title: any) {
    super(OrbitaxExcelMemoConfig.CreateEmptyMemoApi);
    this.projectId = '[PROJECT_ID]';
  }
}


export class DownloadExcelMemoReportCommand extends CommandBase {
  projectId: string;
  constructor(public memoId: string) {
    super(OrbitaxExcelMemoConfig.DownloadExcelMemoReportApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class UpdateMemoCommand extends CommandBase {
  projectId: string;
  constructor(public payload: any) {
    super(OrbitaxExcelMemoConfig.UpdateMemoApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class UpdateTaskMemoReportCommand extends CommandBase {
  projectId: string;
  constructor(public memoId: any) {
    super(OrbitaxExcelMemoConfig.UpdateTaskMemoReportApi);
    this.projectId = '[PROJECT_ID]';
  }
}
